import React from 'react';
import { L as LAYOUTS } from '../../defaults-0542c304.js';
import { RCEHelpersPropTypes } from '../rce-helpers-context/index.js';
import { OptionPropTypes } from './types.js';
import 'wix-rich-content-common/libs/imageUtils';
import 'prop-types';
import '../poll-context/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollOptionBase extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      loading: false,
      checked: this.isUserChoice()
    });
    __publicField(this, "handleRemove", (e) => {
      e.stopPropagation();
      this.props.remove();
    });
    __publicField(this, "handleVoteClick", async (e) => {
      var _a;
      const { validateUser, onBeforeVote, preventInteraction, preventVoting } = this.props.rce;
      const vote = (_a = this.props.poll.settings.permissions) == null ? void 0 : _a.vote;
      const onVoteClick = onBeforeVote || validateUser;
      e.preventDefault();
      if (e.keyCode || preventInteraction || preventVoting) {
        return;
      }
      if (onVoteClick) {
        onVoteClick({ voteRole: vote }).then(this.toggleVote.bind(this), () => {
        });
      } else {
        this.toggleVote();
      }
    });
    __publicField(this, "handleTitleChange", (title) => {
      const { update, option } = this.props;
      return update(__spreadProps(__spreadValues({}, option), { title }));
    });
    __publicField(this, "handleImageChange", (url) => {
      const { update, option } = this.props;
      const newOption = __spreadProps(__spreadValues({}, option), { image: { src: { url } } });
      return update(newOption);
    });
  }
  isEditAllowed() {
    return !this.props.option.count && !this.props.rce.isPreview;
  }
  isUserChoice() {
    var _a;
    const { poll, option } = this.props;
    return !!((_a = poll.ownVotes) == null ? void 0 : _a.includes(option.id));
  }
  isViewMode() {
    return this.props.rce.isViewMode;
  }
  isGridLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.GRID;
  }
  isListLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.LIST;
  }
  isImageEnabled() {
    var _a;
    return (_a = this.props.layout.options) == null ? void 0 : _a.enableImage;
  }
  async toggleVote() {
    this.setState({ loading: true });
    try {
      if (this.isUserChoice()) {
        await this.props.unvote(this.props.option.id);
        this.setState({ checked: false });
      } else {
        await this.props.vote(this.props.option.id);
        this.setState({ checked: true });
      }
    } catch (error) {
    } finally {
      this.setState({ loading: false });
    }
  }
  getVotePercentage() {
    const { option } = this.props;
    return option.rating || 0;
  }
  render() {
    if (this.isViewMode()) {
      return this.renderViewMode();
    }
    return this.renderEditMode();
  }
}
__publicField(PollOptionBase, "propTypes", __spreadValues(__spreadValues({}, OptionPropTypes), RCEHelpersPropTypes));

export { PollOptionBase };
//# sourceMappingURL=PollOptionBase.js.map
